import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/agreeTerms';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

export function getGetPersonalInformation() {
    return get(`${url}/getPersonalInformation`);
};

export function postAgreePersonalInformation(data) {
    return post(`${url}/agreePersonalInformation`, data, { ...options, repeatRequestCancel: true });
};

export function postUpdateAgreePersonalInformation(data) {
    return post(`${url}/updateAgreePersonalInformation`, data, { ...options, repeatRequestCancel: true });
}

export function postNeedPersonalInformation(data) {
    return post(`${url}/needPersonalInformation`, data, { ...options, repeatRequestCancel: true });
}
